import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";

interface NotificationSettings {
  new_like: boolean;
  new_match: boolean;
  new_message: boolean;
  profile_visible: boolean;
  meet_me_email: boolean;
  weekly_matches: boolean;
  local_events: boolean;
  upgrades_billing: boolean;
  marketing: boolean;
  other_emails: boolean;
}

interface NotificationState {
  settings: NotificationSettings | null;
  loading: boolean;
  error: string | null;
  getNotificationSettings: (userId: number) => Promise<void>;
  updateNotificationSettings: (userId: number, settings: NotificationSettings) => Promise<void>;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  settings: null,
  loading: false,
  error: null,

  getNotificationSettings: async (userId) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.post("/getUserNotificationSettings", { id: userId });
      set({ settings: response.data });
    } catch (error: any) {
      console.error("Error fetching notification settings:", error);
      set({ error: error.response?.data?.message || "Failed to fetch notification settings" });
    } finally {
      set({ loading: false });
    }
  },

  updateNotificationSettings: async (userId, settingsData) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.post("/updateUserNotificationSettings", {
        id: userId,
        ...settingsData
      });

      set({ settings: response.data.setting });
    } catch (error: any) {
      console.error("Error updating notification settings:", error);
      set({ error: error.response?.data?.message || "Failed to update notification settings" });
    } finally {
      set({ loading: false });
    }
  }
}));
